var React = require('react');

function Marketscan (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"6.5","cy":"7","r":"2","fill":"#7BA770","key":0}),React.createElement("circle",{"cx":"11.5","cy":"7","r":"1.75","stroke":"#7BA770","strokeWidth":"0.5","key":1}),React.createElement("path",{"d":"M1 9.99964L1 12.3633L3.57143 12.3633","stroke":"#7BA770","key":2}),React.createElement("path",{"d":"M1 3.36364V1H3.57143","stroke":"#7BA770","key":3}),React.createElement("path",{"d":"M16.5713 9.99964L16.5713 12.3633L13.9999 12.3633","stroke":"#7BA770","key":4}),React.createElement("path",{"d":"M16.5713 3.36364L16.5713 1L13.9999 1","stroke":"#7BA770","key":5})]);
}

Marketscan.defaultProps = {"width":"18","height":"13","viewBox":"0 0 18 13","fill":"none"};

module.exports = Marketscan;

Marketscan.default = Marketscan;
